/** Landing page: what the site is and where to start. */
export function HomePage() {
  return (
    <div className="home-page">
      <section className="question-card home-hero">
        <h1>Practice the dMAT Core Module under real exam conditions.</h1>
        <p>
          Unlimited, exam-faithful questions for all three Core Module subtests — every one
          generated from the official transformation rules, every block run against the real
          clock: <strong>20 items in 25 minutes</strong>, <strong>75 seconds per question</strong>,
          no pause, no scratchpad. Answer, and you get the worked solution immediately.
        </p>
        <div className="home-actions">
          <a className="question-submit" href="/drill">
            Start a drill
          </a>
          <a className="auth-secondary" href="/exam">
            Take an exam block
          </a>
          <a className="drill-exit" href="/stats">
            View your stats
          </a>
        </div>
        <p className="muted">
          Works without an account — everything is saved on this device. Create an account any
          time to sync across devices.
        </p>
      </section>

      <section className="home-subtests">
        <div className="question-card home-subtest">
          <h2 className="question-card-title">Figure Sequences</h2>
          <p>
            A 4×4 matrix of figures moves by hidden rules — bouncing, border traversal, colour
            cycles. Work out the next two frames.
          </p>
          <p className="muted">2 answers per item · 25 min / 20 items</p>
        </div>
        <div className="question-card home-subtest">
          <h2 className="question-card-title">Mathematical Equations</h2>
          <p>
            A system of 2–4 equations, one integer solution per letter. Solve it in your head —
            exactly one answer is guaranteed.
          </p>
          <p className="muted">All letters per item · 25 min / 20 items</p>
        </div>
        <div className="question-card home-subtest">
          <h2 className="question-card-title">Latin Squares</h2>
          <p>
            A 5×5 grid where every letter appears once per row and column. Deduce the one cell
            that matters — sometimes by filling others in your mind first.
          </p>
          <p className="muted">1 answer per item · 25 min / 20 items</p>
        </div>
      </section>
    </div>
  )
}
